<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.75 2.75V18.3333C2.75 18.5764 2.84658 18.8096 3.01849 18.9815C3.19039 19.1534 3.42355 19.25 3.66667 19.25H19.25V17.4167H4.58333V2.75H2.75Z"
            fill="#22303E" fill-opacity="0.9" />
        <path
            d="M14.0189 13.4811C14.1039 13.5663 14.205 13.6339 14.3162 13.68C14.4274 13.7261 14.5466 13.7498 14.667 13.7498C14.7874 13.7498 14.9066 13.7261 15.0178 13.68C15.129 13.6339 15.23 13.5663 15.315 13.4811L19.8984 8.89773L18.6022 7.60156L14.667 11.5368L12.565 9.4349C12.48 9.3497 12.379 9.2821 12.2678 9.23598C12.1566 9.18987 12.0374 9.16613 11.917 9.16613C11.7966 9.16613 11.6774 9.18987 11.5662 9.23598C11.455 9.2821 11.3539 9.3497 11.2689 9.4349L6.68555 14.0182L7.98171 15.3144L11.917 11.3791L14.0189 13.4811Z"
            fill="#22303E" fill-opacity="0.9" />
    </svg>

</template>